import React, { useContext, useState ,useEffect} from 'react';
import { CiSearch } from "react-icons/ci";
import  SearchBar from '../../../Components/SearchBar';
import { TrendingContext } from '../../context/TrendingContext';


function TrendingHeading() {
  const {setQuery}=useContext(TrendingContext);
  const[Query ,setquery]=useState('');

  const [searchdata ,setSearchData]=useState([]);

  function changeHandler(e){
    // console.log(Query);
    setquery(e.target.value);
  }
  function setSearchHandler(){
    if(Query.length>0)setQuery(Query);
    else return ;
  }
  useEffect(()=>{
    if(Query!==0&&Query.length>0){
    const response=fetch(`https://api.tvmaze.com/search/shows?q=${Query}`)
    .then(res=>res.json())
    .then((data)=>{setSearchData(data)}).catch((err)=>console.error(err))
    }
  },[Query])
  return (
    <>
  <div className=' mt-10 font-bold text-3xl  w-11/12 h-30 bg-richwhite-50 rounded-lg shadow-md border text-center p-2 mx-auto ' >Crypto-Trending</div>
<div className='flex flex-col flex-wrap justify-center items-center'>

<div className='flex flex-col gap-x-4 justify-center items-center mt-10 '>
  <div className='mb-1'>
  <input 
  type="search" 
  value={Query}
  placeholder='Search'  
  onChange={changeHandler}
  className=' rounded-xl  py-2 border-yellow-2 ring-2 w-[600px] text-center'/>
  
  <button onClick={setSearchHandler}
  className="text-center text-sky-900 rounded-md font-bold hover:ring-3 text-3xl p-1 w-[30px]"><CiSearch /></button>
  </div>
</div>
  <div className='flex w-[550px] rounded-lg bg-slate-100 flex-col gap-y-1'>{
    searchdata.map((ele)=>{
      return <div className=''>{ele.show.name}</div>
      })
    }
  </div>
</div>
  </>
  )
}
export default TrendingHeading;